// extracted by mini-css-extract-plugin
module.exports = {"footer":"FooterMobile_footer__9C5bX","newsletterSection":"FooterMobile_newsletterSection__4t2jZ","scrollTop":"FooterMobile_scrollTop__kD7WT"};